import { render, staticRenderFns } from "./betaversionmodal.vue?vue&type=template&id=32c063dc&scoped=true"
var script = {}
import style0 from "./betaversionmodal.vue?vue&type=style&index=0&id=32c063dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c063dc",
  null
  
)

export default component.exports